import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const QRTimer = ({ initialTime = 15 * 60, onExpire = () => { } }) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);

    useEffect(() => {
        if (timeLeft <= 0) {
            onExpire()
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);


    const minutes = Math.floor(timeLeft / 60);
    const seconds = "" + (timeLeft % 60);
    return (
        <>
            <Typography>
                {minutes}M : {seconds.padStart(2, '0')}S
            </Typography>
        </>
    )
}

export default QRTimer
